import queryKeys from '@/constants/queryKeys';
import appRoutes from '@/constants/routes/app';
import { patchChangeProviderStatus } from '@/services/api/requests/providers';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import useToast from '../useToast';
import { TCustomAxiosError } from '@/services/api';

const useChangeProviderActivity = (id: string) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const toast = useToast();

  const { isPending, isSuccess, mutate } = useMutation({
    mutationFn: async ({ isActive }: { isActive: boolean }) => {
      const response = await patchChangeProviderStatus({ isActive, id });
      return response;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [queryKeys.providers.all, queryKeys.providers.byId, id] });
      toast({ status: 'success', title: 'Success', description: 'Provider status successfully changed.' });
      navigate({ to: appRoutes.providers });
    },
    onError: (error: TCustomAxiosError) => {
      toast({ status: 'error', title: 'Error on changing provider status', description: error.errors?.[0]?.message });
    },
  });

  return { isPending, isSuccess, mutate };
};

export default useChangeProviderActivity;
